import React, { useState } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import Logo from './Logo';
import BtnSignIn from './BtnSignIn';

interface ButtonProps {
  $margin?: string;
  $padding?: string;
  $border?: string;
  $bgColor?: string;
  $color?: string;
  $borderRadius?: string;
  $height?: string;
  $width?: string;
  $fontSize?: string;
  $transition?: string;
  $hoverColor?: string;
  $hoverBgColor?: string;
  $hoverBorder?: string;
}

interface TraceProps {
  $isChecked?: boolean;
}

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 90px;
  color: rgb(0, 0, 0);
  background: #eeeeee;
  font-size: 1.8rem;
  line-height: 2rem;
  z-index: 1000;
`;

const DivNavButtons = styled.div.withConfig({
    shouldForwardProp: prop => prop !== 'rightPosition'
  })<{ rightPosition?: string }>`
  position: absolute;
  right: ${({ rightPosition }) => rightPosition || 'auto'};
  left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  @media (max-width: 1200px) {
    display: none;
  }
`;

const DivNavButtonsMobile = styled.div.withConfig({
    shouldForwardProp: prop => prop !== 'rightPosition'
  })<{ rightPosition?: string }>`
  display: none;  

  @media (max-width: 1200px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

export const Button = styled.button<ButtonProps>`
  margin: ${({ $margin }) => $margin || '10px'};
  padding: ${({ $padding }) => $padding || '10px 15px'};
  border: ${({ $border }) => $border || '2px solid #000'};
  background: ${({ $bgColor }) => $bgColor || '#eeeeee'};
  color: ${({ $color }) => $color || '#000'};
  cursor: pointer;
  border-radius: ${({ $borderRadius }) => $borderRadius || '5px'};
  height: ${({ $height }) => $height};
  width: ${({ $width }) => $width};
  font-weight: bold;
  font-size: ${({ $fontSize }) => $fontSize};
  white-space: nowrap;
  transition: ${({ $transition }) => $transition || '0.3s ease-in-out'};

  &:hover {
    color: ${({ $hoverColor }) => $hoverColor || '#fff'};
    background: ${({ $hoverBgColor }) => $hoverBgColor || '#3ea78d'};
    border: ${({ $hoverBorder }) => $hoverBorder || '2px solid #3ea78d'};
  }
`;

const MenuMobile = styled.div`
  display: none;

  @media (max-width: 1200px) {
    display: flex;
    width: 100%;
      
  }
`;

const CheckboxWrapper = styled.div`
  position: absolute;
  right: 20px;  
  top: 5px;
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  cursor: pointer;

  @media only screen and (max-width: 600px) {
    top: 0;
    height: 15px;
    width: 15px;
  }
`;

const Trace = styled.div<TraceProps>`
  width: 45px;
  height: 5px;
  background-color: #156498;
  position: absolute;
  border-radius: 8px;
  transition: 0.5s ease-in-out;

  &:nth-child(1) {
    top: 15px;
    transform: rotate(0);
  }

  &:nth-child(2) {
    top: 35px;
    transform: rotate(0);
  }

  &:nth-child(3) {
    top: 55px;
    transform: rotate(0);
  }

  @media only screen and (max-width: 600px) {
    width: 15px;
    height: 0.2rem;
    border-radius: 2px;

    &:nth-child(1) {
      top: 38px;
      transform: rotate(0);
    }

    &:nth-child(2) {
      top: 45px;
      transform: rotate(0);
    }

    &:nth-child(3) {
      top: 52px;
      transform: rotate(0);
    }

    ${(props) =>
      props.$isChecked &&
      `
      &:nth-child(1) {
        transform: rotate(45deg);
        top: 42px;
      }

      &:nth-child(2) {
        transform: translateX(-100px);
        width: 30px;
        visibility: hidden;
        opacity: 0;
      }

      &:nth-child(3) {
        transform: rotate(-45deg);
        top: 42px;
      }
    `}
  }

  ${(props) =>
    props.$isChecked &&
    `
      &:nth-child(1) {
        transform: rotate(45deg);
        top: 30px;
      }

      &:nth-child(2) {
        transform: translateX(-100px);
        width: 30px;
        visibility: hidden;
        opacity: 0;
      }

      &:nth-child(3) {
        transform: rotate(-45deg);
        top: 30px;
      }
  `}
`;

const ToggleInput = styled.input`
  display: none;

  &:checked ~ ${CheckboxWrapper} {
    background-color: #eeeeee;
  }
`;

const LabelCheckbox = styled.label``;

const DivMenuList = styled.div<{ $isVisible?: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #eeeeee;
  text-align: center;
  height: 500px;
  width: 100%;
  top: 90px;
   
  transition: opacity 0.5s ease-in-out, visibility 0s 0.5s, z-index 0s 0.5s;

  visibility: ${(props) => (props.$isVisible ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.$isVisible ? '1' : '0')};
  z-index: ${(props) => (props.$isVisible ? '1' : '-1')};
`;

interface HeaderProps {
  home: boolean;
}

const Header: React.FC<HeaderProps> = ({ home })  => {
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);

  const toggleMenu = () => setIsMenuVisible((prevState) => !prevState);

  return (
    <HeaderContainer>
      <Logo />
      <DivNavButtons rightPosition="200px">
        <Link href="https://www.webproject.com.br/users/sign-up/" passHref>
          <Button>COMECE GRÁTIS</Button>
        </Link>
        <Link href="https://www.webproject.com.br/contato/" passHref>
          <Button>PEÇA UMA DEMONSTRAÇÃO</Button>
        </Link>
        <BtnSignIn/>
      </DivNavButtons>


       <MenuMobile>
          <CheckboxWrapper>
            <ToggleInput
              type="checkbox"
              id="toggle"
              checked={isMenuVisible}
              onChange={toggleMenu}
            />
            <LabelCheckbox htmlFor="toggle">
              <Trace $isChecked={isMenuVisible} />
              <Trace $isChecked={isMenuVisible} />
              <Trace $isChecked={isMenuVisible} />
            </LabelCheckbox>
          </CheckboxWrapper>

          <DivMenuList $isVisible={isMenuVisible}>
            <DivNavButtonsMobile>
              <Link href="https://www.webproject.com.br/users/sign-up/" passHref>
                <Button>COMECE GRÁTIS</Button>
              </Link>
              <Link href="https://www.webproject.com.br/contato/" passHref>
                <Button>PEÇA UMA DEMONSTRAÇÃO</Button>
              </Link>
              <BtnSignIn/>
            </DivNavButtonsMobile>
          </DivMenuList>
       </MenuMobile>
    </HeaderContainer>
  );
};

export default Header;